import axios from 'axios';

export const ReportsPageApi = {
  loadEmailList: filter =>
    axios.get(`/api/public/reports/email?filter=${filter}`),
  deleteEmail: data => axios.delete(`/api/public/reports/email/${data.email}`),
  addEmail: ( email) =>
    axios.post(`/api/public/reports/email?email=${email}`),

};